import { Constants } from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import apiService from "@utils/apiService";
import { verifyApiResponse } from "@utils/apiResponseHelper";
import { blobDownload } from "@utils/utilities";

const initialState = {
  loading: false,
  error: false,
  selectedAssessment: {},
  printingGartnerAssessment: false,
};

export const gartnerAssessmentDetailsSlice = createSlice({
  name: "gartnerAssessmentDetails",
  initialState,
  reducers: {
    gartnerAssessmentDetailsStart: (state) => ({
      ...state,
      loading: true,
      error: false,
    }),
    gartnerAssessmentDetailsSuccess: (state, action) => ({
      ...state,
      loading: false,
      error: false,
      selectedAssessment: action.payload,
    }),
    gartnerAssessmentDetailsFailure: (state) => ({
      ...state,
      loading: false,
      error: true,
    }),
    setPrintingGartnerAssessment: (state, action) => {
      state.printingGartnerAssessment = action.payload;
    },
    resetGartnerAssessmentDetails: () => ({
      ...initialState,
    })
  },
});

export const { 
  gartnerAssessmentDetailsStart,
  gartnerAssessmentDetailsSuccess,
  gartnerAssessmentDetailsFailure,
  resetGartnerAssessmentDetails,
  setPrintingGartnerAssessment,
} = gartnerAssessmentDetailsSlice.actions;

export const getGartnerAssessmentDetails = (assessmentCode) => (dispatch) => {
  dispatch(gartnerAssessmentDetailsStart());
  apiService.get(Constants.API.GARTNER_ASSESSMENT_DETAILS + assessmentCode).then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      let ifDataExists = Object.keys(data?.data);
      if (ifDataExists?.length > 0) {
        dispatch(gartnerAssessmentDetailsSuccess(data?.data));
      } else {
        dispatch(gartnerAssessmentDetailsFailure());
      }
    } else {
      dispatch(gartnerAssessmentDetailsFailure());
    }
  }).catch(() => {
    dispatch(gartnerAssessmentDetailsFailure());
  })
};

export const exportGartnerAssessmentInExcel = (assessmentCode) => async () => {
  return apiService
    .post(
      `${Constants.API.GARTNER_ASSESSMENT_DETAILS}${Constants.API.SCORE_CARD_EXPORT_EXCEL}/${assessmentCode}`,
      {},
      {
        responseType: "blob",
      }
    )
    .then((response) => {
      const contentDisposition = response.headers["content-disposition"];
      const parts = contentDisposition.split("filename=");
      const filename = parts[1] ? parts[1].trim() : null;
      blobDownload(
        response.data,
        filename || Constants.SCORECARD.EXPORT_FILE_NAME
      );
    })
}

export default gartnerAssessmentDetailsSlice.reducer;
